export default __webpack_public_path__ + "static/media/a.d63b14b3.jpg";